import { Group } from '@mantine/core';
import * as React from 'react';
import { Form_StringInputProps } from '../../../../../../react-commons/components/form/inputs/Form_StringInput';
import { Inputs } from '../../../../../../react-commons/utils/form/inputs';
import { usePropertyInfo } from '../../../hooks/usePropertyInfo';
import { PropertyValidationInformation } from '../../../util/PropertyValidationInformation';

export const Form_PropertyNameInput = <T extends object>({
    readOnly,
    labelOverride,
    propertyValidationInformation: { propertyIdentifier, resourceType, resourceId },
    hideLabel,
    rightSectionExtend,
    ...props
}: Omit<
    Form_StringInputProps<T, false>,
    'nullable' | 'label' | 'labelInfo' | 'severity' | 'helperText' | 'endingIcon' | 'rightSection'
> & {
    labelOverride?: string;
    propertyValidationInformation: PropertyValidationInformation;
    hideLabel?: boolean;
    rightSectionExtend?: React.ReactElement;
}) => {
    const propertyInfo = usePropertyInfo({
        propertyIdentifier,
        resourceType,
        resourceId,
        hideLabel,
        labelOverride,
        readOnly,
    });

    return (
        <Inputs.String
            nullable={false}
            endingIcon={
                <Group gap={1}>
                    {rightSectionExtend}
                </Group>
            }
            {...propertyInfo}
            {...props}
            helperText={propertyInfo.helperText ? [propertyInfo.helperText] : undefined}
        />
    );
};
